/* eslint-disable import/prefer-default-export */
export const PRECISIONS = new Map([
  [1 / 32, 'Thirty-Second'],
  [1 / 16, 'Sixteenth'],
  [1 / 8, 'Eighth'],
  [1 / 4, 'Quarter'],
  [1 / 3, 'Third'],
  [1 / 2, 'Half'],
  [1, 'Whole'],
  [2, 'Breve'],
  [3, 'Triple'],
  [4, 'Longa'],
  [8, 'Maxima'],
]);
